import { SvgIcon, type SvgIconProps } from './svgIcon'

export const MenuIcon = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={`${width}px`}
    height={`${height}px`}
    viewBox={`0 0 ${(width as number) * 1.3} ${(height as number) * 1.3}`}
    {...props}>
    <g>
      <path
        d="M0,3.875c0-1.104,0.896-2,2-2h20.75c1.104,0,2,0.896,2,2s-0.896,2-2,2H2C0.896,5.875,0,4.979,0,3.875z M22.75,10.375H2
        c-1.104,0-2,0.896-2,2c0,1.104,0.896,2,2,2h20.75c1.104,0,2-0.896,2-2C24.75,11.271,23.855,10.375,22.75,10.375z M22.75,18.875H2
        c-1.104,0-2,0.896-2,2s0.896,2,2,2h20.75c1.104,0,2-0.896,2-2S23.855,18.875,22.75,18.875z"
        fill={fill}
      />
    </g>
  </SvgIcon>
)
